import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostBonusesCreate = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_BONUSES_REFERRALS
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostBonusesCreate as SetPostBonusesCreate
}